export function getCurrentTimestamp(dateOnly: boolean = false): string {
    const date = new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const datePart = yyyy + '-' + mm + '-' + dd;

    if (dateOnly) {
      return datePart;
    }

    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return datePart + ' ' + hh + ':' + min + ':' + ss;
  }